<template>
    <teleport to="body">
        <div v-if="visible" style="position:fixed;inset:0" :style="{zIndex: zBase + 9}" @click.stop="close" @touchend.stop.prevent="close" @contextmenu.stop.prevent="close"></div>
        <div v-if="visible" class="fm-context-menu" :style="menuStyle" @click.stop @touchend.stop @touchmove.stop>
            <template v-if="targetItem">
                <template v-if="pickerMode">
                    <button v-if="targetItem.type === 'file'" class="fm-context-item" @click="handlePreview">
                        <span class="fm-context-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg></span>
                        {{ $t('common.fileManager.preview') }}
                    </button>
                    <button v-if="targetItem.type === 'file' && targetItem.publicUrl && targetItem.publicUrl !== '#'" class="fm-context-item" @click="handleDownload">
                        <span class="fm-context-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg></span>
                        {{ $t('common.fileManager.download') }}
                    </button>
                    <button v-if="targetItem.type === 'folder'" class="fm-context-item" @click="handleOpen">
                        <span class="fm-context-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/></svg></span>
                        {{ $t('common.fileManager.open') }}
                    </button>
                    <template v-if="targetItem.type === 'file' && pickerEntityFolder">
                        <div class="fm-context-divider"></div>
                        <button class="fm-context-item" @click="handleRename">
                            <span class="fm-context-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg></span>
                            {{ $t('common.fileManager.rename') }}
                        </button>
                    </template>
                    <template v-if="pickerEntityFolder && targetItem.type === 'file'">
                        <div v-if="pickerCanDetach || pickerCanDelete" class="fm-context-divider"></div>
                        <button v-if="pickerCanDetach" class="fm-context-item" @click="handleDetach">
                            <span class="fm-context-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 7l-10 10"/><path d="M8 2v4"/><path d="M2 8h4"/><path d="M22 16h-4"/><path d="M16 22v-4"/></svg></span>
                            {{ $t('common.fileManager.detach') }}
                        </button>
                        <button v-if="pickerCanDelete" class="fm-context-item fm-context-item--danger" @click="handleDelete">
                            <span class="fm-context-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg></span>
                            {{ $t('common.fileManager.delete') }}
                        </button>
                    </template>
                </template>
                <template v-else>
                    <template v-if="isSingleTarget">
                        <button v-if="targetItem.type === 'file'" class="fm-context-item" @click="handlePreview">
                            <span class="fm-context-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg></span>
                            {{ $t('common.fileManager.preview') }}
                        </button>
                        <button v-if="targetItem.type === 'file' && targetItem.publicUrl && targetItem.publicUrl !== '#'" class="fm-context-item" @click="handleDownload">
                            <span class="fm-context-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg></span>
                            {{ $t('common.fileManager.download') }}
                        </button>
                        <button v-if="targetItem.type === 'folder'" class="fm-context-item" @click="handleOpen">
                            <span class="fm-context-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/></svg></span>
                            {{ $t('common.fileManager.open') }}
                        </button>
                        <button v-if="entityNavInfo" class="fm-context-item" @click="handleNavigateEntity">
                            <span class="fm-context-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg></span>
                            {{ $t('common.fileManager.navigateToContent') }}
                        </button>
                        <button v-if="source === 'sidebar' && targetItem.type === 'folder' && !isVirtualTarget" class="fm-context-item" @click="handleNewSubFolder">
                            <span class="fm-context-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/><line x1="12" y1="11" x2="12" y2="17"/><line x1="9" y1="14" x2="15" y2="14"/></svg></span>
                            {{ $t('common.fileManager.newSubFolder') }}
                        </button>
                    </template>
                    <template v-if="isTrashMode">
                        <div v-if="isSingleTarget" class="fm-context-divider"></div>
                        <button class="fm-context-item" @click="handleRestore">
                            <span class="fm-context-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/></svg></span>
                            {{ $t('common.fileManager.restore') }}
                        </button>
                        <button class="fm-context-item fm-context-item--danger" @click="handlePermanentDelete">
                            <span class="fm-context-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg></span>
                            {{ $t('common.fileManager.permanentDelete') }}
                        </button>
                    </template>
                    <template v-else>
                        <template v-if="canModifyTarget">
                            <div v-if="isSingleTarget" class="fm-context-divider"></div>
                            <button v-if="isSingleTarget" class="fm-context-item" @click="handleRename">
                                <span class="fm-context-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg></span>
                                {{ $t('common.fileManager.rename') }}
                            </button>
                            <template v-if="targetItem.type === 'folder' && targetItems.length <= 1">
                                <div class="fm-context-submenu" @mouseenter="showColorMenu = true" @mouseleave="showColorMenu = false">
                                    <button class="fm-context-item" @click.stop="showColorMenu = !showColorMenu; showMoveMenu = false">
                                        <span class="fm-context-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="13.5" cy="6.5" r="2.5"/><circle cx="19" cy="13" r="2.5"/><circle cx="16" cy="20" r="2.5"/><circle cx="8" cy="20" r="2.5"/><circle cx="5" cy="13" r="2.5"/><circle cx="12" cy="12" r="3"/></svg></span>
                                        {{ $t('common.fileManager.changeColor') }}
                                        <svg style="margin-left:auto;width:12px;height:12px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg>
                                    </button>
                                    <div v-if="showColorMenu" class="fm-context-submenu-list fm-color-palette">
                                        <button v-for="c in folderColors" :key="c" class="fm-color-dot"
                                                :class="{'fm-color-dot--active': targetItem.color === c}"
                                                :style="{background: c}"
                                                @click="handleColorChange(c)"></button>
                                    </div>
                                </div>
                            </template>
                            <div v-if="isRealFolderContext" class="fm-context-submenu" @mouseenter="showMoveMenu = true" @mouseleave="showMoveMenu = false">
                                <button class="fm-context-item" @click.stop="showMoveMenu = !showMoveMenu; showColorMenu = false">
                                    <span class="fm-context-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg></span>
                                    {{ $t('common.fileManager.move') }}
                                    <svg style="margin-left:auto;width:12px;height:12px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg>
                                </button>
                                <div v-if="showMoveMenu" class="fm-context-submenu-list">
                                    <button v-if="!_allTargetsAreRootFolders" class="fm-context-item" @click="handleMove(null)">
                                        <span class="fm-context-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/></svg></span>
                                        {{ $t('common.fileManager.rootDirectory') }}
                                    </button>
                                    <div v-if="!_allTargetsAreRootFolders && moveFolders.length" class="fm-context-divider"></div>
                                    <button v-for="folder in moveFolders" :key="folder.id" class="fm-context-item"
                                            @click="handleMove(folder.id)">
                                        <span class="fm-context-icon fm-icon-color--folder"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/></svg></span>
                                        {{ folder.name }}
                                    </button>
                                </div>
                            </div>
                        </template>
                        <template v-if="isEntityFolder && targetItem.type === 'file'">
                            <div v-if="isSingleTarget" class="fm-context-divider"></div>
                            <button class="fm-context-item" @click="handleDetach">
                                <span class="fm-context-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 7l-10 10"/><path d="M8 2v4"/><path d="M2 8h4"/><path d="M22 16h-4"/><path d="M16 22v-4"/></svg></span>
                                {{ $t('common.fileManager.detach') }}
                            </button>
                        </template>
                        <template v-if="!isVirtualTarget">
                            <div v-if="(isSingleTarget || canModifyTarget) && !isEntityFolder" class="fm-context-divider"></div>
                            <button class="fm-context-item fm-context-item--danger" @click="handleDelete">
                                <span class="fm-context-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg></span>
                                {{ $t('common.fileManager.delete') }}
                            </button>
                        </template>
                    </template>
                </template>
            </template>
            <template v-else>
                <template v-if="pickerMode">
                    <button v-if="pickerEntityFolder" class="fm-context-item" @click="handleUpload">
                        <span class="fm-context-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg></span>
                        {{ $t('common.fileManager.uploadFile') }}
                    </button>
                    <div v-if="pickerEntityFolder" class="fm-context-divider"></div>
                    <button class="fm-context-item" @click="handleSelectAll">
                        <span class="fm-context-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg></span>
                        {{ $t('common.fileManager.selectAll') }}
                    </button>
                </template>
                <template v-else>
                <button v-if="isRealFolderContext && !isTrashMode" class="fm-context-item" @click="handleNewFolder">
                    <span class="fm-context-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/><line x1="12" y1="11" x2="12" y2="17"/><line x1="9" y1="14" x2="15" y2="14"/></svg></span>
                    {{ $t('common.fileManager.newFolder') }}
                </button>
                <button v-if="canUploadHere && !isTrashMode" class="fm-context-item" @click="handleUpload">
                    <span class="fm-context-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg></span>
                    {{ $t('common.fileManager.uploadFile') }}
                </button>
                <div v-if="(isRealFolderContext || canUploadHere) && !isTrashMode" class="fm-context-divider"></div>
                <button class="fm-context-item" @click="handleSelectAll">
                    <span class="fm-context-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg></span>
                    {{ $t('common.fileManager.selectAll') }}
                </button>
                <template v-if="isTrashMode && hasTrashItems">
                    <div class="fm-context-divider"></div>
                    <button class="fm-context-item" @click="handleRestoreAll">
                        <span class="fm-context-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/></svg></span>
                        {{ $t('common.fileManager.restoreAll') }}
                    </button>
                    <button class="fm-context-item fm-context-item--danger" @click="handleEmptyTrash">
                        <span class="fm-context-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg></span>
                        {{ $t('common.fileManager.emptyTrash') }}
                    </button>
                </template>
                </template>
            </template>
        </div>
    </teleport>
</template>

<script>
import fileManagerService from './fileManagerService'

const FOLDER_COLORS = [
    '#3B82F6', '#10B981', '#F59E0B', '#EF4444',
    '#8B5CF6', '#EC4899', '#F97316', '#06B6D4',
    '#6B7280', '#84CC16',
]

export default {
    name: 'FileManagerContextMenu',
    props: {
        zBase: { type: Number, default: 100000 },
        activeCategory: { type: String, default: 'ALL' },
        pickerMode: { type: Boolean, default: false },
        pickerEntityFolder: { type: Boolean, default: false },
        pickerCanDelete: { type: Boolean, default: false },
        pickerCanDetach: { type: Boolean, default: false },
    },
    emits: ['rename', 'delete', 'move', 'preview', 'download', 'newFolder', 'newSubFolder', 'upload', 'selectAll', 'open', 'colorChange', 'navigateEntity', 'restore', 'permanentDelete', 'restoreAll', 'emptyTrash', 'detach'],
    beforeUnmount() {
        this._unlockBodyScroll()
    },
    data() {
        return {
            visible: false,
            targetItem: null,
            targetItems: [],
            x: 0,
            y: 0,
            showMoveMenu: false,
            showColorMenu: false,
        }
    },
    computed: {
        menuStyle() {
            return {
                position: 'fixed',
                left: this.x + 'px',
                top: this.y + 'px',
                zIndex: this.zBase + 10,
            }
        },
        moveFolders() {
            const excluded = this._excludedFolderIds
            return fileManagerService.state.folders.filter(f => !f.moduleType && !f.entityId && !excluded.has(f.id))
        },
        _excludedFolderIds() {
            const set = new Set()
            const items = this.targetItems.length > 0 ? this.targetItems : (this.targetItem ? [this.targetItem] : [])
            const folders = fileManagerService.state.folders
            for (const item of items) {
                if (item.type !== 'folder') continue
                set.add(item.id)
                const addDescendants = (parentId) => {
                    for (const f of folders) {
                        if (f.parentId === parentId && !f.moduleType && !f.entityId) {
                            set.add(f.id)
                            addDescendants(f.id)
                        }
                    }
                }
                addDescendants(item.id)
            }
            return set
        },
        _targetIsAtRoot() {
            if (!this.targetItem || this.targetItem.type !== 'folder') return false
            const folder = fileManagerService.state.folders.find(f => f.id === this.targetItem.id)
            return folder ? folder.parentId === null : true
        },
        _allTargetsAreRootFolders() {
            const items = this.targetItems.length > 0 ? this.targetItems : (this.targetItem ? [this.targetItem] : [])
            if (!items.length) return false
            const folders = fileManagerService.state.folders
            return items.every(i => {
                if (i.type !== 'folder') return false
                const f = folders.find(f => f.id === i.id)
                return f ? f.parentId === null : true
            })
        },
        folderColors() {
            return FOLDER_COLORS
        },
        isSingleTarget() {
            return this.targetItems.length <= 1
        },
        isTrashMode() {
            return this.activeCategory === 'TRASH' && this.source !== 'sidebar'
        },
        isVirtualTarget() {
            return !!(this.targetItem?.moduleType || this.targetItem?.entityId)
        },
        canModifyTarget() {
            if (this.isVirtualTarget) return false
            if (this.isRealFolderContext) return true
            if (this.targetItem?.type === 'file') return true
            return false
        },
        currentFolder() {
            const id = fileManagerService.state.currentFolderId
            return id ? fileManagerService.state.folders.find(f => f.id === id) : null
        },
        isRealFolderContext() {
            if (!this.currentFolder) return this.activeCategory === 'ALL'
            return !this.currentFolder.moduleType && !this.currentFolder.entityId
        },
        hasTrashItems() {
            return fileManagerService.state.files.length > 0 || fileManagerService.state.trashFolders.length > 0
        },
        isEntityFolder() {
            return !!(this.currentFolder?.entityId)
        },
        canUploadHere() {
            const f = this.currentFolder
            if (!f) return true
            if (f.moduleType) return false
            if (f.entityId) return f.directUpload !== false
            return true
        },
        entityNavInfo() {
            if (this.targetItem?.entityId) {
                return { type: this.targetItem.uploadableType, id: this.targetItem.entityId }
            }
            if (this.targetItem?.type === 'file' && this.currentFolder?.entityId) {
                return { type: this.currentFolder.uploadableType, id: this.currentFolder.entityId }
            }
            return null
        },
    },
    methods: {
        openAt(event, item, items, source) {
            this.targetItem = item
            this.targetItems = items || []
            this.source = source || 'content'
            this.showMoveMenu = false
            this.showColorMenu = false
            let x = event.clientX
            let y = event.clientY
            const menuW = 200
            const menuH = 260
            if (x + menuW > window.innerWidth) x = window.innerWidth - menuW - 10
            if (y + menuH > window.innerHeight) y = window.innerHeight - menuH - 10
            this.x = Math.max(0, x)
            this.y = Math.max(0, y)
            this.visible = true
            this._openedAt = Date.now()
            this._lockBodyScroll()
        },
        close(force) {
            if (!force && this._openedAt && Date.now() - this._openedAt < 400) return
            this.visible = false
            this.showMoveMenu = false
            this.showColorMenu = false
            this._unlockBodyScroll()
        },
        _lockBodyScroll() {
            if (this._bodyScrollHandler) return
            this._bodyScrollHandler = (e) => {
                if (!e.target.closest('.fm-context-submenu-list')) e.preventDefault()
            }
            document.addEventListener('touchmove', this._bodyScrollHandler, { passive: false, capture: true })
        },
        _unlockBodyScroll() {
            if (!this._bodyScrollHandler) return
            document.removeEventListener('touchmove', this._bodyScrollHandler, { capture: true })
            this._bodyScrollHandler = null
        },
        isTargetSelf(folderId) {
            return this.targetItem?.id === folderId
        },
        handlePreview() {
            this.$emit('preview', this.targetItem)
            this.close()
        },
        handleDownload() {
            this.$emit('download', this.targetItem)
            this.close()
        },
        handleOpen() {
            this.$emit('open', this.targetItem)
            this.close()
        },
        handleRename() {
            this.$emit('rename', { item: this.targetItem, source: this.source })
            this.close()
        },
        handleDelete() {
            const uids = this.targetItems.length > 0 ? this.targetItems.map(i => i.uid) : [this.targetItem.uid]
            this.$emit('delete', uids)
            this.close()
        },
        handleRestore() {
            const uids = this.targetItems.length > 0 ? this.targetItems.map(i => i.uid) : [this.targetItem.uid]
            this.$emit('restore', uids)
            this.close()
        },
        handlePermanentDelete() {
            const uids = this.targetItems.length > 0 ? this.targetItems.map(i => i.uid) : [this.targetItem.uid]
            this.$emit('permanentDelete', uids)
            this.close()
        },
        handleNewSubFolder() {
            this.$emit('newSubFolder', this.targetItem)
            this.close()
        },
        handleMove(folderId) {
            const uids = this.targetItems.length > 0 ? this.targetItems.map(i => i.uid) : [this.targetItem.uid]
            this.$emit('move', { ids: uids, folderId })
            this.close()
        },
        handleColorChange(color) {
            if (this.targetItem) {
                fileManagerService.setFolderColor(this.targetItem.id, color)
            }
            this.close()
        },
        handleNavigateEntity() {
            this.$emit('navigateEntity', this.entityNavInfo)
            this.close()
        },
        handleNewFolder() {
            this.$emit('newFolder')
            this.close()
        },
        handleUpload() {
            this.$emit('upload')
            this.close()
        },
        handleDetach() {
            const uids = this.targetItems.length > 0 ? this.targetItems.map(i => i.uid) : [this.targetItem.uid]
            this.$emit('detach', uids)
            this.close()
        },
        handleSelectAll() {
            this.$emit('selectAll')
            this.close()
        },
        handleRestoreAll() {
            this.$emit('restoreAll')
            this.close()
        },
        handleEmptyTrash() {
            this.$emit('emptyTrash')
            this.close()
        },
    },
}
</script>
